import React from 'react';
import PropTypes from 'prop-types';
import request from '../../request';
import Files from './components/files';
import Upload from './components/upload';
import { Link, Route } from 'react-router-dom';
import EditStudy from './components/edit-study';
import DeleteStudy from './components/delete-study';

const statuses = {
  pending: 'Pending',
  progress: 'In Progress',
  scored: 'Scored',
};
export default class Study extends React.Component {
  constructor({ location }) {
    super();
    let { state } = location;
    this.state = {
      study: state ? state.study : null,
    };
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    if (!id) this.context.router.history.replace('/');
    this.canDownload();
  }

  async canDownload() {
    let { id } = this.props.match.params;
    if (!id) this.context.router.history.replace('/');
    try {
      let {
        study,
        canDownloadStudy,
        canDownloadResults,
        canDownloadReport,
      } = await request({ url: `studies/${id}` });
      this.setState({
        claim: true,
        study,
        canDownloadStudy,
        canDownloadResults,
        canDownloadReport,
      });
      this.context.router.history.replace({
        pathname: `/study/${id}`,
        state: { study },
      });
    } catch (e) {
      this.context.router.history.replace('/');
    }
  }

  async claim(claim = true) {
    let { study } = this.state;

    try {
      this.setState({ loading: true });
      let response = await request({
        url: `studies/${study.id}/claim`,
        method: 'PATCH',
        body: {
          claim,
        },
      });
      this.setState({ study: response, loading: false });
      this.context.router.history.replace({
        pathname: `/study/${study.id}`,
        state: { study: response },
      });
    } catch (e) {
      console.log(e);
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.location.state &&
      nextProps.location.state !== this.props.location.state
    )
      this.setState({
        study: nextProps.location.state.study,
        ...nextProps.location.state.download,
      });
  }

  render() {
    let {
      claim,
      study,
      loading,
      canDownloadStudy,
      canDownloadResults,
      canDownloadReport,
    } = this.state;
    if (!study) return null;
    let type = localStorage.getItem('type');

    return (
      <div style={{ opacity: loading ? 0.5 : 1 }}>
        <div id="study-head">
          <div id="study-title">Study</div>
          <div id="study-uuid">#{study.old_id || study.id}</div>
          <div id="subnav">
            {type === 'admin'
              ? <Link className="edit" to={`/study/${study.id}/reupload`}>
                  Reup Study
                </Link>
              : null}
            {type === 'admin'
              ? <Link
                  className="edit"
                  to={`/study/${study.id}/reupload-report`}
                >
                  Reup Report
                </Link>
              : null}
            {type === 'admin'
              ? <Link
                  className="edit"
                  to={`/study/${study.id}/reupload-results`}
                >
                  Reup Results
                </Link>
              : null}
            {type === 'admin' || type === 'staff' || type === 'company admin'
              ? <Link className="edit" to={`/study/${study.id}/edit`}>
                  Edit Study
                </Link>
              : null}
            {type === 'admin' || type === 'company admin'
              ? <Link className="study-delete" to={`/study/${study.id}/delete`}>
                  Delete Study
                </Link>
              : null}
          </div>
        </div>
        <div id="study-main" className={`status-${study.status || 'progress'}`}>
          <div id="single">
            <div id="details">
              <div className="item ss-user">
                <span>Patient</span>
                <strong>{study.patient_name}</strong>
              </div>
              <div className="item ss-stopwatch">
                <span>Status</span>
                <strong>{statuses[study.status]}</strong>
              </div>
              <div className="item ss-tag">
                <span>Type</span>
                <strong>{study.study_type.name}</strong>
              </div>
              <div className="item ss-uploadcloud">
                <span>Uploader</span>
                <strong>{study.uploaded_by.display_name}</strong>
              </div>
              <div className="item ss-buildings">
                <span>Company</span>
                <strong>{study.company.name}</strong>
              </div>
              <div className="item ss-briefcase">
                <span>Assignee</span>
                <strong className={study.scored_by ? null : 'low'}>
                  {study.scored_by
                    ? study.scored_by.display_name
                    : 'Unassigned'}
                </strong>
              </div>
              <div className="item ss-addcalendar">
                <span>Last Updated</span>
                <strong>
                  {study.updated_ago}
                </strong>
              </div>
              <div className="item ss-addcalendar">
                <span>Added</span>
                <strong>
                  {study.time_ago}
                </strong>
              </div>
              <div className="item ss-checkcalendar">
                <span>Scored</span>
                <strong className={study.score_date ? null : 'low'}>
                  {study.scored_ago ? study.scored_ago : 'Not scored yet'}
                </strong>
              </div>
            </div>
            <Files
              study={study}
              canDownloadStudy={canDownloadStudy}
              canDownloadResults={canDownloadResults}
              canDownloadReport={canDownloadReport}
              claim={claim ? value => this.claim(value) : null}
            />
          </div>

          <Route
            path="/study/:id/edit"
            component={props =>
              <EditStudy
                claim={value => this.claim(value)}
                setStudy={study => this.setState({ study })}
                study={study}
                {...props}
              />}
          />

          <Route
            path="/study/:id/results"
            render={props =>
              <Upload
                type="results"
                study={study}
                download={{ canDownloadResults: true }}
                {...props}
              />}
          />

          <Route
            path="/study/:id/report"
            render={props =>
              <Upload
                type="report"
                study={study}
                download={{ canDownloadReport: true }}
                {...props}
              />}
          />

          <Route
            path="/study/:id/reupload"
            render={props =>
              <Upload
                type="reupload/study"
                title="Reupload Study"
                study={study}
                download={{ canDownloadStudy: true }}
                {...props}
              />}
          />

          <Route
            path="/study/:id/reupload-results"
            render={props =>
              <Upload
                type="reupload/results"
                title="Reupload Results"
                study={study}
                download={{ canDownloadResults: true }}
                {...props}
              />}
          />

          <Route
            path="/study/:id/reupload-report"
            render={props =>
              <Upload
                type="reupload/report"
                title="Reupload Report"
                study={study}
                download={{ canDownloadReport: true }}
                {...props}
              />}
          />

          <Route
            path="/study/:id/delete"
            component={props => <DeleteStudy id={study.id} {...props} />}
          />
        </div>
      </div>
    );
  }
}

Study.contextTypes = {
  router: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/views/dashboard/study.js